import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-x1"
}

import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import PDPLink from '@/shared/navigation/PDPLink.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketLineItemEditModuleConfiguration',
  props: {
    sku: null,
    editGuid: null,
    configurationGuid: null
  },
  setup(__props: any) {




const labels = useBlockLabels();

return (_ctx: any,_cache: any) => {
  return (__props.configurationGuid)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(PDPLink, {
          sku: __props.sku,
          "edit-guid": __props.editGuid,
          "configuration-guid": __props.configurationGuid,
          class: "text-14 text-dusty-grey hover:text-dusty-grey c-magic-line c-magic-line--underline"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(labels).lineItemEditLinkText), 1)
          ]),
          _: 1
        }, 8, ["sku", "edit-guid", "configuration-guid"])
      ]))
    : _createCommentVNode("", true)
}
}

})